<template>
    <button-base styleType="default">
        <slot></slot>
    </button-base>
</template>
